// extracted by mini-css-extract-plugin
module.exports = {"logosHolder":"LogosFooter_logosHolder__2cc2a"};